export const AUDIT_TEMPLATE_PATH = "/audit";

export const EMAIL_TEMPLATES_PATH = "/email-templates";

export const MESSAGE_TEMPLATES_PATH = "/message-templates";

export const REGION_AND_CAMPAIGNS_PATH = "/location";

export const USER_MANAGEMENT_PATH = "/user-management";

export const DASHBOARD_PATH = "/dashboard";

export const DISCOVERY_PATH = "/discovery";

export const QUESTION_BANK_PATH = "/question-bank";

export const POSITIONS_PATH = "/positions";

export const CHANGE_PASSWORD_PATH = "/change-password";

export const CANDIDATE_APPLIED_POSITIONS_PATH = "/applied/positions";

export const CAREERS_PATH = "/careers";

export const CUSTOM_REPORT_PATH = "/custom-report";

export const CANDIDATE_REPOSITORY_PATH = "/candidate_repository";
